// Hands a composed Train session from the Train hero to the player route without
// serializing it through the URL. Consumed once on the play screen.
import type { ComposedSession } from "./session-composer";

let pending: ComposedSession | null = null;

export function setPendingSession(s: ComposedSession): void {
  pending = s;
}
export function takePendingSession(): ComposedSession | null {
  const s = pending;
  pending = null;
  return s;
}
